module.exports = __webpack_public_path__ + "assets/certificate_pdf/MCTMicrosoft Certified Trainer_H589-2317_20201201.093669a5.pdf";